import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./ReviewSection.css";

const reviews = [
    {
        name: "hue Jhnn",
        time: "vor 6 Tagen",
        rating: 4,
        text: "Ich habe nie viel von Selbstfindung gehalten.  War immer sehr kritisch gegenüber den Methoden und dachte mir „Das kann nur Unfug sein“ Auf eine direkte Empfehlung bin ich zu Chiara gekommen und wahrscheinlich sollte es genau so sein. Es war komisch für mich das Chiara einem mit so viel Liebe, Support und Offenherzigkeit entgegenkommt. Wenn man jahrelang gemobbt wurde, denkt man nicht daran das man von jemand „fremden“ so herzlich aufgenommen werden kann. Chiara hat meine Seele ein großes Stück geheilt, die Zusammenarbeit  mit ihr hat meinem inneren Kind Frieden gegeben. Ich habe heute immer noch harte Tage, aber ich weiß wie ich damit umgehen kann und wie ich mich nicht darin verliere. Ich danke dir von ganzem Herzen Chiara. Ich danke dir dafür, dass meine Kindheit mich im „Jetzt“ nicht mehr negativ beeinflusst. Das ich mir erlaube glücklich zu sein, ohne meinem unrealistischen Ideal zu entsprechen. Einfach danke, das ich mich heute lieben kann. Das du mir gezeigt hast: Es lohnt sich, aufzuarbeiten und zu kämpfen.",
      },
  {
    name: "J. F.",
    time: "vor 3 Monaten",
    rating: 5,
    text: "Chiara lebt für ihr Coach-Dasein. Sie ist jederzeit erreichbar für ihre Klienten und mit ganzem Herzen dabei! Ich kann sie zu 1000 Prozent weiterempfehlen! ♥️",
  },
  {
    name: "Sophie Hügel",
    time: "vor 3 Monaten",
    rating: 5,
    text: "Chiara schafft es mir immer neue Perspektiven zu geben, wenn ich selbst den Fokus verliere. Ich schätze besonders die verschiedenen Techniken ihrer Arbeit, die mich von Anfang an überrascht, fasziniert und überzeugt haben.",
  },
  {
    name: "SNOOKN_",
    time: "vor einem Monat",
    rating: 5,
    text: "endlich ein -GIRLS GIRL- die euch bei eurem emotionalen Stress und generell bei Problemen im Alltag oder allgemein eine super Stütze bietet. Ihr seid hier alle bestens aufgehoben, sie hat Ahnung von dem was Sie tut und das Beste ist, es gibt Ergebnisse! Solche Menschen brauchen wir viel viel mehr.",
  },
  {
    name: "Pinar Kiyar",
    time: "vor 6 Tagen",
    rating: 5,
    text: "Chiara ist einer der wundervollsten und liebevollsten Menschen, die ich kennenlernen durfte. Sie vereint Wissen, Können und Verständnis in einem. Mit ihr habe ich gelernt meine Emotionen zu ordnen und meinen Fokus zu lenken. Nach jedem Gespräch habe ich mich besser gefühlt. Ich bin so dankbar für all unsere Calls und Gespräche. In Momenten, wo ich nicht klar denken konnte, weil ich so sehr in der Angst war, hat Chiara mir den Weg gezeigt und ich konnte besser damit umgehen. Einfach eine wunderbare Frau und ich kann Sie als Coach und Weg Begleiterin nur empfehlen.",
  },
  {
    name: "Mandy",
    time: "vor 2 Tagen",
    rating: 5,
    text: "Chiara überzeugt mit ihrem tiefen Wissen, authentischem Auftreten und ehrlicher, offener Art. Ihr Business-Coaching ist erstklassig und voller Empowerment. Absolut empfehlenswert!",
  },
];

const ReviewSection = () => {
  return (
    <section className="review-section">
      <h2 className="review-title">Google Reviews</h2>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          768: { slidesPerView: 2 }, // Ab 768px zwei Rezensionen nebeneinander
          1024: { slidesPerView: 3 }, // Ab 1024px drei Rezensionen nebeneinander
        }}
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="review-card">
              <div className="review-header">
                <div>
                  <p className="review-name">{review.name}</p>
                  <p className="review-time">{review.time}</p>
                </div>
              </div>
              <div className="review-rating">
                {"⭐".repeat(review.rating)}
              </div>
              <p className="review-text">{review.text}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <a href="https://g.page/r/CUYbH_5PB9gyEAE/review" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="review-button">
        ⭐ Google Rezensionen ansehen oder schreiben
        </a>

    </section>
  );
};

export default ReviewSection;
